import {URLS} from "@/constants";

export default {
    namespaced: true,

    state: {
        eventSource: null,
        connected: false,
        reconnectAttempts: 0,
        maxReconnectAttempts: 5,
        reconnectDelay: 3000,
        reconnectTimer: null,
    },

    mutations: {
        SET_EVENT_SOURCE(state, eventSource) { state.eventSource = eventSource; },
        SET_CONNECTED(state, connected) { state.connected = connected; },
        INCREMENT_RECONNECT_ATTEMPTS(state) { state.reconnectAttempts++; },
        RESET_RECONNECT_ATTEMPTS(state) { state.reconnectAttempts = 0; },
        SET_RECONNECT_TIMER(state, timer) { state.reconnectTimer = timer; },
    },

    actions: {
        connect({commit, dispatch, state, rootState}, {shopId} = {}) {
            if (state.eventSource) return;
            if (!shopId) return;

            const url = `${URLS.MODEL.APPOINTMENT.STREAM_URL}?shopId=${shopId}`;
            const eventSource = new EventSource(url, {withCredentials: true});

            eventSource.onopen = () => {
                commit("SET_CONNECTED", true);
                commit("RESET_RECONNECT_ATTEMPTS");
            };

            eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    dispatch("handleEvent", data);
                } catch (error) {
                    console.error("[Appointments SSE] Error parsing event:", error);
                }
            };

            eventSource.onerror = () => {
                commit("SET_CONNECTED", false);
                if (eventSource) {
                    eventSource.close();
                    commit("SET_EVENT_SOURCE", null);
                }
                const isAuthorized = rootState.authentication.isAuthorized;
                if (isAuthorized && state.reconnectAttempts < state.maxReconnectAttempts) {
                    commit("INCREMENT_RECONNECT_ATTEMPTS");
                    const timer = setTimeout(() => {
                        commit("SET_RECONNECT_TIMER", null);
                        dispatch("connect", {shopId});
                    }, state.reconnectDelay);
                    commit("SET_RECONNECT_TIMER", timer);
                }
            };

            commit("SET_EVENT_SOURCE", eventSource);
        },

        disconnect({commit, state}) {
            if (state.reconnectTimer) {
                clearTimeout(state.reconnectTimer);
                commit("SET_RECONNECT_TIMER", null);
            }
            if (state.eventSource) {
                state.eventSource.close();
                commit("SET_EVENT_SOURCE", null);
                commit("SET_CONNECTED", false);
                commit("RESET_RECONNECT_ATTEMPTS");
            }
        },

        handleEvent(_, event) {
            if (event.type === "connected" || event.type === "heartbeat" || event.type === "reconnect") return;
            // Emit a DOM event that AppointmentsView listens to for calendar refetch
            window.dispatchEvent(new CustomEvent("appointment-changed", {detail: event}));
        },
    },
};
